export default {
  experienceATE() {
    if (typeof window.setCookieExperience === 'function') {
      // Fonction de barreportail.js (lq-entete-commun)
      window.setCookieExperience(0);
    } else {
      // TODO: 2025-05-22: Retirer ce code après 2026-05-22 ou lorsque lq-entete-commun sera déployé
      const domain = getDomain();
      const nbJour = 90;
      const expirationDate = new Date(Date.now() + nbJour * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `sunriseATE=0;expires=${expirationDate.toUTCString()};domain=${domain};path=/`;
    }

    alerteProjet('ATE');
  },
  experienceMagnolia() {
    if (typeof window.deleteCookieExperience === 'function') {
      // Fonction de barreportail.js (lq-entete-commun)
      window.deleteCookieExperience();
    } else {
      // TODO: 2025-05-22: Retirer ce code après 2026-05-22 ou lorsque lq-entete-commun sera déployé
      // eslint-disable-next-line no-lonely-if
      if (document.cookie.includes('sunriseATE=')) {
        const domain = getDomain();
        document.cookie = `sunriseATE=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${domain};path=/`;
      }
    }

    alerteProjet('Magnolia');
  },
};

// TODO: 2025-05-22: Retirer ce code après 2026-05-22 ou lorsque lq-entete-commun sera déployé
export function getDomain() {
  const domain = window.location.hostname;
  return `.${domain.substring(domain.indexOf('.') + 1)}`;
}

function alerteProjet(projet) {
  // eslint-disable-next-line no-alert
  alert(`Vous êtes sous l'expérience ${projet}`);
}
